import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable, Subject } from 'rxjs';
import { tap } from 'rxjs/operators';

import { environment } from 'environments/environment';

import { Grouping } from '@classes/grouping/grouping';
import { GroupingLists } from '@classes/grouping/grouping-lists';

@Injectable({
    providedIn: 'root'
})
export class GroupingService {
    selectedGroupChanged = new Subject<Grouping>();
    groupsListChanged = new Subject<Grouping[]>();
    publicGroupsListChanged = new Subject<Grouping[]>();

    private baseUrl = environment.apiUrl + 'organisms/groups';

    private groups: Grouping[];

    constructor(
        private http: HttpClient
    ) { }

    getList(): Observable<GroupingLists> {
        return this.http.get<GroupingLists>(this.baseUrl)
        .pipe(
            tap(lists => {
                this.groups = lists.groups;
                this.groupsListChanged.next([ ...this.groups ]);
                this.publicGroupsListChanged.next([ ...lists.publicGroups ]);
            })
        );
    }

    post(group: Grouping): Observable<Grouping> {
        return this.http.post<Grouping>(this.baseUrl, group)
        .pipe(
            tap(groupRes => {
                this.groups.push(groupRes);
                this.groupsListChanged.next([ ...this.groups ]);
                this.selectedGroupChanged.next(null);
            })
        );
    }

    put(group: Grouping): Observable<Grouping> {
        return this.http.put<Grouping>(this.baseUrl, group)
        .pipe(
            tap(groupRes => {
                this.groups = this.groups.map(g => g.code === groupRes.code ? groupRes : g);
                this.groupsListChanged.next([ ...this.groups ]);
                this.selectedGroupChanged.next(null);
            })
        );
    }

    delete(code: string): Observable<void> {
        return this.http.delete<void>(`${this.baseUrl}/${code}`)
        .pipe(
            tap(() => {
                this.groups = this.groups.filter(g => g.code !== code);
                this.groupsListChanged.next([ ...this.groups ]);
                this.selectedGroupChanged.next(null);
            })
        );
    }
}
